import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';

export const PAYMENT_PROCESSING = "PAYMENT_PROCESSING";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_ERROR = "PAYMENT_ERROR";
export const PAYMENT_RESET = "PAYMENT_RESET";


export const processPayment = (data: any) => {

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: PAYMENT_PROCESSING });
        // setTimeout(() => {
        //     dispatch({ type: PAYMENT_SUCCESS, payload: { res: "" } });
        //     dispatch({ type: WHATSAPP_PLAN_FAILED, payload: { error: dummyData.error.error } });
        // }, 2000);

        // let data = {}
        networkCall("post", `/whatsapp/deduct`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.status && res.status === 200) {
                    dispatch({ type: PAYMENT_SUCCESS, payload: { res: res } });
                } else {
                    dispatch({ type: PAYMENT_ERROR, payload: { error: res.error.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: PAYMENT_ERROR, payload: { error } });
                }
            });
    }
}